/*
 * @Author: yzhao
 * @Date: 2022-04-18 14:19:42
 * @LastEditors: yzhao
 * @LastEditTime: 2022-09-25 15:17:08
 * @Description: file content
 */
export default [
    { method: 'openapi.singleitem.synchronize', name: '商品同步接口' },
    { method: 'openapi.items.synchronize', name: '商品同步接口（批量）' },
    { method: 'openapi.singleitem.push', name: '商品同步下发接口' },
    { method: 'openapi.combineitem.synchronize', name: '组合商品同步接口' },
    { method: 'openapi.singleitem.query', name: '商品查询接口' },
    { method: 'openapi.packuom.singleitem.synchronize', name: '包装同步接口' },
    { method: 'openapi.entryorder.create', name: '入库单创建接口' },
    { method: 'openapi.entryorder.batchcreate', name: '入库单创建接口（批量）' },
    { method: 'openapi.entryorder.receive', name: '入库单接收接口' },
    { method: 'openapi.entryorder.confirm', name: '入库单确认接口' },
    { method: 'openapi.stockin.push', name: '入库单下发接口' },
    { method: 'openapi.entryorder.update', name: '入库单更新接口' },
    { method: 'openapi.entryorder.batchupdate', name: '入库单更新接口（批量）' },
    { method: 'openapi.saleorder.create', name: '销售订单创建接口' },
    { method: 'openapi.saleorder.confirm', name: '销售订单确认接口' },
    { method: 'openapi.stockout.create', name: '出库单创建接口' },
    { method: 'openapi.stockout.batchcreate', name: '出库单创建接口（批量）' },
    { method: 'openapi.stockout.confirm', name: '出库单确认接口' },
    { method: 'openapi.stockout.query', name: '出库单查询接口' },
    { method: 'openapi.stockout.push', name: '出库单下发接口' },
    { method: 'openapi.transport.create', name: '运单创建接口' },
    { method: 'openapi.routing.receive', name: '订单路由跟踪接口' },
    { method: 'openapi.routing.push', name: '订单路由下发接口' },
    { method: 'openapi.inventory.query', name: '库存查询接口' },
    { method: 'openapi.conditioninventory.query', name: '库存查询接口（多条件）' },
    { method: 'openapi.inventory.report', name: '库存盘点通知接口' },
    { method: 'openapi.order.cancel', name: '单据取消接口' },
    { method: 'openapi.storeprocess.create', name: '仓内加工单创建接口' },
    { method: 'openapi.storeprocess.confirm', name: '仓内加工单确认接口' },
    { method: 'openapi.adjustmentorder.create', name: '库存转移单创建接口' },
    { method: 'openapi.adjustmentorder.confirm', name: '库存转移单确认接口' },
    { method: 'openapi.waybill.get', name: '快递面单获取' },
    { method: 'openapi.stockout.close', name: '出库单关闭' },
    { method: 'openapi.user.synchronize', name: '用户创建接口' },
    { method: 'openapi.serialno.synchronize', name: '序列号创建接口' }
]



// WEBPACK FOOTER //
// ./src/data/openapi/apis.js